module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "LiveHotel"
    }
  }, [_c('launch', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    attrs: {
      "loaded": _vm.loaded
    },
    on: {
      "closeload": _vm.closeload
    }
  }), _vm._v(" "), (_vm.isShowNoWatchQrCode) ? _c('noWatchTips', {
    attrs: {
      "message": "请使用手机微信扫码打开",
      "ds_id": _vm.ds_id,
      "channel_id": _vm.channel_id
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isBlack) ? _c('tipsView', {
    attrs: {
      "message": _vm.blackMessage
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isyxinImLoginOut) ? _c('tipsView', {
    attrs: {
      "message": "你在其他端登陆，刷新后可以重新登陆!"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.registerViewShow) ? _c('RegisterView', {
    attrs: {
      "fans_id": _vm.fans_id,
      "ds_id": _vm.ds_id
    },
    on: {
      "registerOk": _vm.registerOk,
      "closeload": _vm.registerViewClose
    }
  }) : _vm._e(), _vm._v(" "), (_vm.TelTestShow) ? _c('TelTest', {
    staticStyle: {
      "z-index": "9900"
    },
    attrs: {
      "fans_id": _vm.fans_id,
      "ds_id": _vm.ds_id,
      "show_type": _vm.show_type,
      "need_check_bool": _vm.need_check_bool
    },
    on: {
      "whiteNumOk": _vm.whiteNumOk
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showhead),
      expression: "showhead"
    }],
    staticClass: "headtitle",
    style: ('background:' + _vm.headtitleBg)
  }, [_c('p', {
    staticClass: "ellipsis"
  }, [_vm._v(_vm._s(_vm.titleName))])]), _vm._v(" "), (_vm.topAD) ? _c('topAd', {
    attrs: {
      "topObj": _vm.topObj
    },
    on: {
      "closeAD": _vm.closeAD
    }
  }) : _vm._e(), _vm._v(" "), (_vm.fullscr && _vm.isIOS) ? _c('div', {
    staticClass: "videoMusk"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "flex-direction": "column"
    },
    style: ({
      'flex-direction': _vm.threeScreenDirection
    })
  }, [_c('div', {
    staticClass: "player"
  }, [(_vm.showLivePlayer) ? _c('TFPlayer', {
    ref: "tfPlayer",
    attrs: {
      "initData": _vm.initData,
      "fans_id": _vm.fans_id,
      "videoIndex": _vm.videoIndex,
      "selectPlayType": _vm.selectPlayType,
      "showH5Xianlu": _vm.isThreeScreen,
      "isThreeScreen": _vm.isThreeScreen,
      "runObj": _vm.runObj,
      "copyrightObj": _vm.copyrightObj
    },
    on: {
      "statusChange": _vm.playerStatusChange,
      "linkTypeChange": _vm.linkTypeChange,
      "isSupportRTC": _vm.isSupportRTCCallBack,
      "unAutoPlay": _vm.unAutoPlay,
      "playFailed": _vm.playFailed,
      "playerListener": _vm.playerListener,
      "showH5XianluAlert": function($event) {
        _vm.showLiveWay = true
      }
    }
  }) : _c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": _vm.initData && _vm.initData.direct_seeding.pic_url
    }
  }), _vm._v(" "), (_vm.isShowTeacherBtnTop) ? _c('div', {
    staticClass: "showTeacherBtnTop",
    on: {
      "click": _vm.showTeacherBtnTopClicked
    }
  }, [_c('img', {
    attrs: {
      "src": "https://shanhu-live-1317978474.cos.ap-guangzhou.myqcloud.com/web/common/rad_heart.png"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.hot) ? _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showView),
      expression: "showView"
    }],
    staticClass: "view_num",
    style: ('margin-top:' + _vm.barHeight + 'px')
  }, [_c('img', {
    staticStyle: {
      "margin-top": "-5px"
    },
    attrs: {
      "src": "https://tengfaceliveuser.tengface.net/web/wx-user/img/hot_num.png"
    }
  }), _vm._v("\n          " + _vm._s(_vm.view_num) + "\n        ")]) : _vm._e()], 1), _vm._v(" "), (_vm.isThreeScreen) ? _c('div', {
    staticClass: "player"
  }, [_c('whiteboard', {
    ref: "whiteboard",
    attrs: {
      "fans_id": _vm.fans_id,
      "im_type": _vm.im_type,
      "direct_status": _vm.directStatus,
      "ds_id": _vm.ds_id
    },
    on: {
      "errorReport": _vm.errorReport,
      "changPosion": _vm.changeScreenPostion
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "floatBox",
    style: ('margin-top:' + _vm.playHeight + 'px')
  }, [(_vm.isTrySee && (_vm.directStatus == 'end' || _vm.videoIndex != 0) && !_vm.is_pay) ? _c('div', {
    staticClass: "trySee",
    style: ('opacity:' + _vm.tryOpacity)
  }, [_vm._v("\n      试看" + _vm._s(_vm.tryTime) + "秒，付费观看完整版\n    ")]) : _vm._e(), _vm._v(" "), (_vm.isTrySee && (_vm.directStatus == 'end' || _vm.videoIndex != 0) && !_vm.is_pay) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tryPayBtn && !_vm.fullscr),
      expression: "tryPayBtn && !fullscr"
    }],
    staticClass: "tryPay",
    style: ('margin-top:' + _vm.barHeight + 'px'),
    on: {
      "click": _vm.onShowPay
    }
  }, [_vm._v("\n      付费\n    ")]) : _vm._e(), _vm._v(" "), (_vm.openRolling) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isRolling),
      expression: "isRolling"
    }],
    staticClass: "scrollbar",
    style: ('margin-top:' + _vm.marqueeheight + 'px' + _vm.marqueeStyle)
  }, [_c('p', {
    directives: [{
      name: "dompurify-html",
      rawName: "v-dompurify-html",
      value: (_vm.MerryGoRound),
      expression: "MerryGoRound"
    }]
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "window",
    on: {
      "click": _vm.swichWindow
    }
  }, [(_vm.forbid) ? _c('img', {
    attrs: {
      "src": _vm.imgPath + 'room/fly-g.png'
    }
  }) : _c('img', {
    attrs: {
      "src": _vm.imgPath + 'room/fly-w.png'
    }
  })]), _vm._v(" "), (_vm.musicStatusexist) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.musicStatus),
      expression: "musicStatus"
    }],
    staticClass: "music",
    class: {
      musicPlay: _vm.musicPlay
    },
    style: ('margin-top:' + _vm.barHeight + 'px'),
    attrs: {
      "id": "music"
    },
    on: {
      "click": _vm.setMusic
    }
  }, [(_vm.musicPlay) ? _c('img', {
    attrs: {
      "src": _vm.imgPath + 'home/music.png'
    }
  }) : _c('img', {
    attrs: {
      "src": _vm.imgPath + 'home/music1.png'
    }
  }), _vm._v(" "), _c('audio', {
    attrs: {
      "autoplay": "autoplay",
      "id": "audio",
      "src": _vm.musicUrl
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.allot_sale) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isPlayUI),
      expression: "!isPlayUI"
    }],
    staticClass: "allot_btn",
    on: {
      "click": _vm.onShowAllot
    }
  }, [_c('span', [_vm._v("邀")]), _vm._v(" "), _c('span', [_vm._v("邀请好友")])]) : _vm._e(), _vm._v(" "), (_vm.shareRedexist) ? _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.shareRed),
      expression: "shareRed"
    }],
    staticClass: "shareRed",
    attrs: {
      "id": "shareRed"
    }
  }, [_vm._v("\n      分享得\n      "), (_vm.shareType == 0) ? [_vm._v("红包")] : [_vm._v("卡券")]], 2) : _vm._e(), _vm._v(" "), (_vm.talkredexist) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.talkred && !_vm.isPlay),
      expression: "talkred && !isPlay"
    }],
    staticClass: "talkred",
    on: {
      "click": _vm.showtalkredpoup
    }
  }, [(_vm.talkType == 0) ? _c('img', {
    attrs: {
      "src": _vm.imgPath + 'home/passred.png'
    }
  }) : _c('img', {
    attrs: {
      "src": _vm.imgPath + 'home/passcard.png'
    }
  })]) : _vm._e()]), _vm._v(" "), (_vm.openShop) ? _c('salesList', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.fullscr && !_vm.forbid && !_vm.isPlay),
      expression: "!fullscr && !forbid && !isPlay"
    }],
    attrs: {
      "fans_id": _vm.fans_id,
      "playHeight": _vm.playHeight
    }
  }) : _vm._e(), _vm._v(" "), (_vm.haveNav) ? _c('pieceWise', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.fullscr),
      expression: "!fullscr"
    }],
    attrs: {
      "currLiveDic": _vm.currLiveDic,
      "playHeight": _vm.playHeight,
      "dsId": _vm.ds_id,
      "breakPoint": _vm.breakPoint,
      "styleType": _vm.styleType,
      "videoIndex": _vm.videoIndex
    },
    on: {
      "switchVideo": _vm.switchVideo
    }
  }) : _vm._e(), _vm._v(" "), (_vm.openShop && _vm.fans_id) ? _c('Top', {
    ref: "top",
    attrs: {
      "fans_id": _vm.fans_id,
      "playHeight": _vm.playHeight,
      "pieceHeight": _vm.pieceHeight
    }
  }) : _vm._e(), _vm._v(" "), (_vm.adImages.length != 0) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowAd),
      expression: "isShowAd"
    }],
    staticClass: "banner",
    style: ({
      'margin-top': (_vm.playHeight + _vm.pieceHeight + _vm.salesHeight) + 'px',
      'height': _vm.bannerHeight + 'px'
    })
  }, [_c('van-swipe', {
    attrs: {
      "autoplay": 5000,
      "show-indicators": false,
      "height": _vm.bannerHeight
    }
  }, _vm._l((_vm.adImages), function(item, index) {
    return _c('van-swipe-item', {
      key: index,
      on: {
        "click": function($event) {
          return _vm.adJumpItemTap(item)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.pic_url
      }
    })])
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.haveMenu) ? _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMenu),
      expression: "showMenu"
    }],
    staticClass: "menu",
    class: {
      noline: _vm.initData && _vm.initData.direct_seeding.play_style != 3
    },
    style: ('margin-top:' +
      (_vm.playHeight + _vm.pieceHeight + _vm.salesHeight + _vm.bannerHeight) +
      'px')
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.initData && _vm.initData.direct_seeding.play_style == 3),
      expression: "initData && initData.direct_seeding.play_style == 3"
    }],
    staticClass: "leftFocus",
    on: {
      "click": function($event) {
        _vm.showLiveWay = true
      }
    }
  }, [_vm._v("\n        线路\n      ")]), _vm._v(" "), _c('van-tabs', {
    class: 'menu' + _vm.styleType,
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "lazy-render": false,
      "lineWidth": _vm.navitemWidth,
      "sticky": "",
      "animated": ""
    },
    on: {
      "click": _vm.handleTabClick
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.openRolling),
      expression: "openRolling"
    }],
    staticClass: "scrollbar",
    staticStyle: {
      "z-index": "10000",
      "background": "#ffeabd",
      "height": "30px",
      "line-height": "30px"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#814000",
      "line-height": "30px"
    }
  }, [_vm._v(_vm._s(_vm.MerryGoRound))])]), _vm._v(" "), _vm._l((_vm.dsMenu), function(item, index) {
    return _c('van-tab', {
      key: index,
      style: (_vm.contentStyle),
      attrs: {
        "title": item.name
      }
    }, [_c('div', {
      staticClass: "home-content",
      style: (_vm.contentStyle)
    }, [(item.cid == 1) ? _c('ChatRoom', {
      ref: "chat",
      refInFor: true,
      attrs: {
        "fans_id": _vm.fans_id,
        "mid": item.mid,
        "dsId": _vm.ds_id,
        "currentMid": _vm.currentMid,
        "playerStatus": _vm.playerStatus,
        "linkType": _vm.linkType,
        "initData": _vm.initData,
        "forbid": _vm.forbid,
        "channel_code": _vm.channel_REL_ID,
        "isLoadHistory": _vm.isLoadHistory,
        "totalLike": _vm.totalLike,
        "dynamicData": _vm.dynamicData,
        "startTime": _vm.startTime,
        "directStatus": _vm.directStatus,
        "openWx_follow": _vm.openWx_follow,
        "isshowCart": _vm.isshowCart,
        "showTeacherBtn": _vm.showTeacherBtn,
        "noticeObj": _vm.noticeObj
      },
      on: {
        "personnum": _vm.personnum,
        "robRedBagAction": _vm.robRedBagAction,
        "sendApplyLink": _vm.sendApplyLink,
        "sendEndLink": _vm.sendEndLink,
        "onShowTeacherList": _vm.onShowTeacherList,
        "onShowGoodsList": _vm.onShowGoodsList,
        "onShowFouceAlert": _vm.onShowFouceAlert
      }
    }) : (item.cid == 2) ? _c('Vote', {
      attrs: {
        "mid": item.mid,
        "vid": _vm.vid,
        "currentMid": _vm.currentMid
      },
      on: {
        "switchSider": _vm.switchSider
      }
    }) : (item.cid == 3) ? _c('ImgText', {
      attrs: {
        "mid": item.mid,
        "currentMid": _vm.currentMid,
        "uid": _vm.uid,
        "fans_id": _vm.fans_id
      }
    }) : (item.cid == 4) ? _c('List', {
      attrs: {
        "toplist": _vm.toplist,
        "fans_id": _vm.fans_id,
        "mid": item.mid,
        "currentMid": _vm.currentMid
      }
    }) : (item.cid == 5) ? _c('EmbeddedWeb', {
      attrs: {
        "resuouce": item.content,
        "mid": item.mid,
        "currentMid": _vm.currentMid
      }
    }) : (item.cid == 6) ? _c('shake', {
      attrs: {
        "dispark": _vm.dispark,
        "initData": _vm.initData,
        "mid": item.mid,
        "currentMid": _vm.currentMid
      }
    }) : (item.cid == 7) ? _c('VideoReView', {
      attrs: {
        "mid": item.mid,
        "currentMid": _vm.currentMid
      }
    }) : (item.cid == 8) ? _c('special', {
      attrs: {
        "breakPoint": _vm.breakPoint,
        "dsId": _vm.ds_id,
        "mid": item.mid,
        "currentMid": _vm.currentMid
      },
      on: {
        "switchVideo": _vm.switchVideo
      }
    }) : (item.cid == 9) ? _c('Store', {
      attrs: {
        "resuouce": _vm.StoreUrl
      }
    }) : _vm._e()], 1)])
  })], 2)], 1)]) : _vm._e(), _vm._v(" "), (_vm.isThreeScreen) ? _c('div', {
    staticClass: "home-content",
    style: (_vm.contentStyle)
  }, [_vm._l((_vm.dsMenu), function(item, index) {
    return [(item.cid == 1) ? _c('ChatRoom', {
      ref: "chat",
      refInFor: true,
      attrs: {
        "fans_id": _vm.fans_id,
        "mid": item.mid,
        "dsId": _vm.ds_id,
        "currentMid": _vm.currentMid,
        "playerStatus": _vm.playerStatus,
        "linkType": _vm.linkType,
        "initData": _vm.initData,
        "forbid": _vm.forbid,
        "channel_code": _vm.channel_REL_ID,
        "isLoadHistory": _vm.isLoadHistory,
        "totalLike": _vm.totalLike,
        "dynamicData": _vm.dynamicData,
        "startTime": _vm.startTime,
        "directStatus": _vm.directStatus,
        "openWx_follow": _vm.openWx_follow,
        "isshowCart": _vm.isshowCart,
        "showTeacherBtn": _vm.showTeacherBtn,
        "noticeObj": _vm.noticeObj,
        "isThreeScreen": _vm.isThreeScreen
      },
      on: {
        "personnum": _vm.personnum,
        "robRedBagAction": _vm.robRedBagAction,
        "sendApplyLink": _vm.sendApplyLink,
        "sendEndLink": _vm.sendEndLink,
        "onShowTeacherList": _vm.onShowTeacherList,
        "onShowGoodsList": _vm.onShowGoodsList,
        "onShowFouceAlert": _vm.onShowFouceAlert,
        "changeVideoLine": function($event) {
          _vm.showLiveWay = true
        }
      }
    }) : _vm._e()]
  })], 2) : _vm._e(), _vm._v(" "), [_c('leftBar', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.fullscr),
      expression: "!fullscr"
    }],
    ref: "left",
    attrs: {
      "curCid": _vm.curCid,
      "voteList": _vm.voteList,
      "showBigTable": _vm.showBigTable,
      "isPlay": _vm.isPlay,
      "TstartTime": _vm.TstartTime,
      "Tend_time": _vm.Tend_time,
      "fans_id": _vm.fans_id
    }
  }), _vm._v(" "), _c('rightBar', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    ref: "right",
    attrs: {
      "styleType": _vm.styleType,
      "fans_id": _vm.fans_id,
      "headerUrl": _vm.headerUrl
    }
  }), _vm._v(" "), _c('toolBar', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.curCid == 1 && !_vm.fullscr),
      expression: "curCid == 1 && !fullscr"
    }],
    ref: "toolbar",
    attrs: {
      "styleType": _vm.styleType,
      "isWeixin": _vm.isWeixin,
      "picComment": _vm.picComment,
      "isshowgift": _vm.isshowgift,
      "verify_comment": _vm.verify_comment,
      "commentList": _vm.commentList,
      "isIOS": _vm.isIOS,
      "fans_id": _vm.fans_id,
      "isMaster": _vm.isMaster,
      "giftList": _vm.giftList,
      "wallSign": _vm.wallSign,
      "wall_id": _vm.wall_id,
      "payPrice": _vm.payPrice,
      "directStatus": _vm.directStatus,
      "is_all_users_muted": _vm.is_all_users_muted,
      "say_self": _vm.say_self
    },
    on: {
      "switchSider": _vm.switchSider,
      "showtalk": _vm.showtalk,
      "colsetalkred": _vm.colsetalkred,
      "loginIM": _vm.loginIM
    }
  }), _vm._v(" "), _c('ConsultTeacher', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showConsultTeacher),
      expression: "showConsultTeacher"
    }],
    ref: "consultTeacher",
    attrs: {
      "dsId": _vm.ds_id,
      "fansId": _vm.fans_id,
      "tid": _vm.tid
    },
    on: {
      "closeBtnClicked": _vm.consultTeacherCloseBtnClicked
    }
  }), _vm._v(" "), _c('goodsList', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showGoods),
      expression: "showGoods"
    }],
    ref: "goodsList",
    attrs: {
      "dsId": _vm.ds_id,
      "fansId": _vm.fans_id,
      "tid": _vm.tid,
      "gid": _vm.gid,
      "uid": _vm.uid,
      "channel_id": _vm.channel_id,
      "goodsIds": _vm.goodsIdsList
    },
    on: {
      "closeBtnClicked": _vm.goodsListCloseBtnClicked
    }
  })], _vm._v(" "), (!_vm.fullscr) ? _c('redRain', {
    ref: "redrain",
    attrs: {
      "rainProbab": _vm.rainProbab,
      "rainId": _vm.rainId,
      "fans_id": _vm.fans_id
    }
  }) : _vm._e(), _vm._v(" "), (_vm.openShop) ? _c('buyList', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.fullscr && !_vm.forbid),
      expression: "!fullscr && !forbid"
    }],
    attrs: {
      "buyList": _vm.buyList,
      "buyListIndex": _vm.buyListIndex
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isShowLoginErr) ? _c('div', {
    staticStyle: {
      "position": "fixed",
      "bottom": "0",
      "left": "0",
      "right": "0",
      "z-index": "1911",
      "background": "rgba(0, 0, 0, 0.84)"
    },
    style: (_vm.loginErrroStyle)
  }, [_c('van-button', {
    staticStyle: {
      "position": "absolute",
      "top": "50%",
      "left": "50%",
      "transform": "translate(-50%, -50%)"
    },
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.tryLogin
    }
  }, [_vm._v("重新登录")])], 1) : _vm._e(), _vm._v(" "), _c('van-popup', {
    staticStyle: {
      "overflow": "visible"
    },
    model: {
      value: (_vm.talkredstatus),
      callback: function($$v) {
        _vm.talkredstatus = $$v
      },
      expression: "talkredstatus"
    }
  }, [_c('div', {
    staticClass: "sharebao"
  }, [_c('img', {
    staticClass: "gold",
    attrs: {
      "src": _vm.imgPath + 'home/gold.png'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sharehead",
    style: ('background-image:url(' + _vm.imgPath + 'home/sharebg.jpg)')
  }, [_c('div', {
    staticClass: "height25"
  }), _vm._v(" "), (_vm.talkType == 0) ? _c('p', [_vm._v("口令红包")]) : _c('p', [_vm._v("口令卡券")]), _vm._v(" "), (_vm.talkType == 0) ? _c('p', {
    staticClass: "loll"
  }, [_vm._v("发送口令得红包")]) : _c('p', {
    staticClass: "loll"
  }, [_vm._v("发送口令得卡券")])]), _vm._v(" "), _c('div', {
    staticClass: "talktext"
  }, [_vm._v(_vm._s(_vm.talktext))]), _vm._v(" "), _c('div', {
    staticClass: "sharebody"
  }, [_c('p', [_vm._v("\n          中奖条件：发送口令即有机会获得\n          "), (_vm.talkType == 0) ? _c('span', [_vm._v("红包")]) : _c('span', [_vm._v("卡券")])]), _vm._v(" "), _c('a', {
    staticClass: "button",
    on: {
      "click": _vm.sedTalk
    }
  }, [_vm._v("发送口令")])])])]), _vm._v(" "), _c('van-popup', {
    staticStyle: {
      "overflow": "visible"
    },
    model: {
      value: (_vm.rewardredpack),
      callback: function($$v) {
        _vm.rewardredpack = $$v
      },
      expression: "rewardredpack"
    }
  }, [_c('div', {
    staticClass: "sharebao"
  }, [_c('img', {
    staticClass: "gold",
    attrs: {
      "src": _vm.imgPath + 'home/gold.png'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sharehead"
  }, [_c('div', {
    staticClass: "height25"
  }), _vm._v(" "), (_vm.rewardType == 1) ? _c('p', [_vm._v("口令红包")]) : [_c('p', [_vm._v("分享红包")]), _vm._v(" "), _c('p', {
    staticClass: "loll"
  }, [_vm._v("分享直播得红包")])]], 2), _vm._v(" "), _c('div', {
    staticClass: "sharebody"
  }, [_c('p', [_vm._v("红包金额：")]), _vm._v(" "), _c('p', {
    staticClass: "money"
  }, [_vm._v("\n          " + _vm._s(_vm.rewardMoney / 100) + "\n          "), _c('span', [_vm._v("元")])]), _vm._v(" "), _c('p', [_vm._v("\n          中奖说明：红包已存入钱包，可\n          "), _c('van-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": _vm.cash
    }
  }, [_vm._v("提现")])], 1), _vm._v(" "), _c('a', {
    staticClass: "button",
    on: {
      "click": _vm.closeRedpack
    }
  }, [_vm._v("确定")])])])]), _vm._v(" "), _c('van-popup', {
    model: {
      value: (_vm.rewardQuan),
      callback: function($$v) {
        _vm.rewardQuan = $$v
      },
      expression: "rewardQuan"
    }
  }, [_c('div', {
    staticClass: "sharebao"
  }, [_c('div', {
    staticClass: "sharehead"
  }, [(_vm.rewardType == 1) ? [_c('p', [_vm._v("口令卡券")]), _vm._v(" "), _c('p', {
    staticClass: "loll"
  }, [_vm._v("发送口令得卡券")])] : [_c('p', [_vm._v("分享卡券")]), _vm._v(" "), _c('p', {
    staticClass: "loll"
  }, [_vm._v("分享直播得卡券")])]], 2), _vm._v(" "), _c('div', {
    staticClass: "sharebody"
  }, [_c('p', [_vm._v("恭喜您获得")]), _vm._v(" "), (_vm.quanData) ? _c('p', {
    staticClass: "money"
  }, [_vm._v("\n          “" + _vm._s(_vm.quanData.coupon_title) + "”\n          "), _c('span', [_vm._v("1张")])]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("\n          中奖说明：卡券已存入“个人中心”-“我的卡包”\n          "), _c('van-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": _vm.cards
    }
  }, [_vm._v("查看")])], 1), _vm._v(" "), _c('a', {
    staticClass: "button",
    on: {
      "click": _vm.closeQuan
    }
  }, [_vm._v("确定")])])])]), _vm._v(" "), _c('van-popup', {
    staticClass: "paydialog",
    attrs: {
      "close-on-click-overlay": false
    },
    model: {
      value: (_vm.showPay),
      callback: function($$v) {
        _vm.showPay = $$v
      },
      expression: "showPay"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("付费观看")]), _vm._v(" "), _c('div', {
    staticClass: "payContent"
  }, [_c('div', {
    staticClass: "tryBox"
  }, [_c('span', {
    staticClass: "moneyIcon"
  }, [_vm._v("￥")]), _vm._v(" "), (_vm.payIndex >= 0) ? _c('span', {
    staticClass: "money"
  }, [(_vm.tryPrice >= parseInt(_vm.coupons[_vm.payIndex].money) / 100) ? [_vm._v(_vm._s((_vm.tryPrice - _vm.coupons[_vm.payIndex].money) / 100))] : [_vm._v("0")]], 2) : _c('span', {
    staticClass: "money"
  }, [_vm._v(_vm._s(_vm.tryPrice / 100))]), _vm._v(" "), (_vm.payIndex >= 0) ? _c('span', {
    staticClass: "oldMoney"
  }, [_vm._v(_vm._s(_vm.tryPrice / 100))]) : _vm._e()]), _vm._v(" "), (_vm.coupons.length) ? _c('ul', {
    staticClass: "coupons"
  }, [_vm._l((_vm.coupons), function(item, index) {
    return _c('li', {
      key: index,
      class: {
        cur: _vm.payIndex == index
      },
      on: {
        "click": function($event) {
          return _vm.select(index, item.id)
        }
      }
    }, [_c('i'), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.money / 100) + "元门票券")])])
  }), _vm._v(" "), _c('li', {
    class: {
      cur: _vm.payIndex == -1
    },
    on: {
      "click": function($event) {
        return _vm.select(-1, 0)
      }
    }
  }, [_c('i'), _vm._v(" "), _c('span', [_vm._v("不使用")])])], 2) : _vm._e(), _vm._v(" "), _c('p', {
    directives: [{
      name: "dompurify-html",
      rawName: "v-dompurify-html",
      value: (_vm.couponText),
      expression: "couponText"
    }],
    staticClass: "explain"
  }, [_vm._v("说明：" + _vm._s(_vm.couponText))])]), _vm._v(" "), _c('div', {
    staticClass: "twobtn"
  }, [_c('a', {
    staticClass: "cancel",
    on: {
      "click": _vm.payCancel
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('a', {
    staticClass: "sure",
    on: {
      "click": _vm.tryPay
    }
  }, [_vm._v("确认购买")])])]), _vm._v(" "), _c('van-popup', {
    model: {
      value: (_vm.showrobRedlist),
      callback: function($$v) {
        _vm.showrobRedlist = $$v
      },
      expression: "showrobRedlist"
    }
  }, [_c('robRedBaglist', {
    attrs: {
      "man": _vm.redBagData,
      "list": _vm.redBaglistData
    },
    on: {
      "close": _vm.closeRodRedList
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAllot),
      expression: "showAllot"
    }],
    staticClass: "musk2",
    on: {
      "click": _vm.onCloseAllot
    }
  }, [_c('div', {
    staticClass: "box allot"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.canvas),
      expression: "!canvas"
    }],
    staticClass: "shareCard",
    attrs: {
      "id": "shareCard"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.base64Img
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "allot_title"
  }, [_vm._v("\n          " + _vm._s(_vm.allot.title) + "\n          "), _c('span', [_vm._v("精选课程")])]), _vm._v(" "), _c('div', {
    staticClass: "allot_price"
  }, [_c('span', {
    staticClass: "yuan"
  }, [_vm._v("￥")]), _vm._v("\n          " + _vm._s(_vm.allot.price / 100) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "allot_ul"
  }, [_vm._v("\n          邀请收益：¥ " + _vm._s(_vm.allot.allot_money / 100) + " / 人\n          "), _c('span'), _vm._v("\n          收益比例：" + _vm._s(_vm.allot.rate * 100) + "％\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "allot_dashed"
  }, [_c('div', {
    staticClass: "allot_dasheds"
  }, _vm._l((30), function(item, index) {
    return _c('span', {
      key: index
    })
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "userInfo clearfix"
  }, [_c('div', {
    staticClass: "userImg fl"
  }, [_c('img', {
    attrs: {
      "src": _vm.headerData,
      "crossorigin": "anonymous"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "name fl"
  }, [(_vm.fans) ? _c('span', {
    staticClass: "colors"
  }, [_vm._v(_vm._s(_vm.fans.nick))]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("给你分享了一堂好课程")]), _vm._v(" "), _c('p', [_vm._v("长按扫码购买")])]), _vm._v(" "), _c('div', {
    staticClass: "code fr"
  }, [_c('img', {
    attrs: {
      "src": _vm.code
    }
  })])]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.canvas),
      expression: "canvas"
    }],
    staticClass: "allot_canvas",
    attrs: {
      "src": _vm.canvas,
      "crossorigin": "anonymous"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "allot_tip"
  }, [_vm._v("长按保存图片，或发送给朋友")])]), _vm._v(" "), _c('div', {
    staticClass: "weixincode"
  }, [_c('van-popup', {
    staticClass: "codebox",
    attrs: {
      "close-on-click-overlay": true
    },
    model: {
      value: (_vm.isShowQRimg),
      callback: function($$v) {
        _vm.isShowQRimg = $$v
      },
      expression: "isShowQRimg"
    }
  }, [_c('div', {
    staticClass: "popup"
  }, [_c('span', {
    staticClass: "focus-on-click"
  }), _vm._v(" "), _c('div', {
    staticClass: "popup-head"
  }, [_c('div', {
    staticClass: "pp-title-top"
  }, [_c('img', {
    attrs: {
      "src": "https://tengfaceliveuser.tengface.net/web/wx-user/img/title-popup.png"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "popup-title"
  }, [_c('strong', {
    staticClass: "balanced",
    staticStyle: {
      "font-size": "15px",
      "font-weight": "bold",
      "color": "#353535"
    }
  }, [_vm._v(_vm._s(_vm.weixintopText))])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://tengfaceliveuser.tengface.net/web/wx-user/img/title-popup.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "popup-body"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "130px"
    },
    attrs: {
      "src": _vm.weixincodeUrl
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "color": "#353535",
      "font-size": "13px",
      "margin-top": "10px"
    }
  }, [_vm._v("\n            - " + _vm._s(_vm.weixinbottomText) + " -\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "popup-end",
    on: {
      "click": function($event) {
        _vm.isShowQRimg = false
      }
    }
  }, [_vm._v("关闭")])])]), _vm._v(" "), _c('van-popup', {
    staticClass: "codebox",
    attrs: {
      "close-on-click-overlay": true
    },
    model: {
      value: (_vm.showLiveWay),
      callback: function($$v) {
        _vm.showLiveWay = $$v
      },
      expression: "showLiveWay"
    }
  }, [_c('div', {
    staticClass: "popup"
  }, [_c('span', {
    staticClass: "focus-on-click"
  }), _vm._v(" "), _c('div', {
    staticClass: "popup-body live-way"
  }, [_c('p', [(_vm.selectPlayType == 2) ? _c('van-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.changePlayType(2)
      }
    }
  }, [_vm._v("普通直播")]) : _c('van-button', {
    on: {
      "click": function($event) {
        return _vm.changePlayType(2)
      }
    }
  }, [_vm._v("普通直播")])], 1), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.tid),
      expression: "!tid"
    }]
  }, [(_vm.selectPlayType == 1) ? _c('van-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.changePlayType(1)
      }
    }
  }, [_vm._v("低延迟线路一")]) : _c('van-button', {
    on: {
      "click": function($event) {
        return _vm.changePlayType(1)
      }
    }
  }, [_vm._v("低延迟线路一")])], 1), _vm._v(" "), _c('p', [(_vm.selectPlayType == 3) ? _c('van-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.changePlayType(3)
      }
    }
  }, [_vm._v("低延迟线路二")]) : _c('van-button', {
    on: {
      "click": function($event) {
        return _vm.changePlayType(3)
      }
    }
  }, [_vm._v("低延迟线路二")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "popup-end",
    on: {
      "click": function($event) {
        _vm.showLiveWay = false
      }
    }
  }, [_vm._v("关闭")])])]), _vm._v(" "), _c('van-popup', {
    staticClass: "codebox",
    attrs: {
      "close-on-click-overlay": false
    },
    model: {
      value: (_vm.isShowTeacherQrCode),
      callback: function($$v) {
        _vm.isShowTeacherQrCode = $$v
      },
      expression: "isShowTeacherQrCode"
    }
  }, [_c('div', {
    staticClass: "popup"
  }, [_c('span', {
    staticClass: "focus-on-click"
  }), _vm._v(" "), _c('div', {
    staticClass: "popup-head"
  }, [_c('div', {
    staticClass: "pp-title-top"
  }, [_c('h3', {
    staticClass: "popup-title"
  }, [_c('strong', {
    staticClass: "balanced",
    staticStyle: {
      "font-size": "15px",
      "font-weight": "bold",
      "color": "#353535"
    }
  }, [_vm._v(_vm._s(_vm.teacher_qrcode_title))])])])]), _vm._v(" "), _c('div', {
    staticClass: "popup-body"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "375px"
    },
    attrs: {
      "src": _vm.teacher_qrcode_url
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "popup-end",
    staticStyle: {
      "background": "#f56c6c",
      "color": "white"
    },
    on: {
      "click": _vm.showTeacherQrCodeCliced
    }
  }, [_vm._v("关闭")])])]), _vm._v(" "), _c('van-popup', {
    staticClass: "qqLogin",
    style: ({
      width: '70%'
    }),
    attrs: {
      "close-on-click-overlay": false,
      "overlay-style": {
        zIndex: '2001'
      }
    },
    model: {
      value: (_vm.showQQPopUp),
      callback: function($$v) {
        _vm.showQQPopUp = $$v
      },
      expression: "showQQPopUp"
    }
  }, [_c('div', {
    staticClass: "loginWay"
  }, [_c('div', {
    staticClass: "qqtitle"
  }, [_vm._v("授权登录")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-around",
      "padding": "20px 0px"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    },
    on: {
      "click": _vm.mploginTap
    }
  }, [_c('img', {
    staticClass: "qqlogoImg",
    attrs: {
      "src": "https://tengfaceliveuser.tengface.net/web/wx-user/img/weChat.png"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_vm._v("微信登录")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    on: {
      "click": _vm.qqloginTap
    }
  }, [_c('img', {
    staticClass: "qqlogoImg",
    attrs: {
      "src": "https://tengfaceliveuser.tengface.net/web/wx-user/img/QQ1.png"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_vm._v("QQ登录")])])])])]), _vm._v(" "), _c('van-popup', {
    staticClass: "qqLogin",
    style: ({
      width: '70%'
    }),
    attrs: {
      "close-on-click-overlay": false,
      "overlay-style": {
        zIndex: '2001'
      }
    },
    model: {
      value: (_vm.isShowMPJumpAlert),
      callback: function($$v) {
        _vm.isShowMPJumpAlert = $$v
      },
      expression: "isShowMPJumpAlert"
    }
  }, [_c('div', {
    staticClass: "loginWay"
  }, [_c('div', {
    staticStyle: {
      "padding": "20px 0px"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("\n             即将打开小程序，进行听课\n          ")]), _vm._v(" "), (_vm.isWeixin) ? _c('div', {
    staticStyle: {
      "margin-top": "35px",
      "text-align": "center"
    }
  }, [_c('wx-open-launch-weapp', {
    attrs: {
      "id": "launch-btn",
      "username": _vm.miniConfig.mp_1v1_orgin_id,
      "path": _vm.weappPathData
    }
  }, [_c('script', {
    attrs: {
      "type": "text/wxtag-template"
    }
  }, [_vm._v("\n              <style>.mpbtn {\n                        background: #07c160;\n                        margin: auto;\n                        border: none;\n                        border-radius: 10px;\n                        color: #ffffff;\n                        padding: 0px 70px;\n                        height: 44px;\n                        font-size:14px;\n                        line-height: 44px;\n                    }</style>\n                <button class=\"mpbtn\">跳转</button>\n              ")])])], 1) : _c('div', {
    staticStyle: {
      "margin-top": "35px",
      "text-align": "center"
    }
  }, [_c('van-button', {
    staticStyle: {
      "padding": "0px 70px",
      "height": "44px",
      "line-height": "44px"
    },
    attrs: {
      "round": "",
      "type": "primary"
    },
    on: {
      "click": _vm.mploginJump
    }
  }, [_vm._v("跳转")])], 1)])])]), _vm._v(" "), _c('van-popup', {
    staticClass: "onlineSchoolLogin",
    style: ({
      width: '100%'
    }),
    attrs: {
      "close-on-click-overlay": false,
      "overlay-style": {
        zIndex: '2001'
      }
    },
    model: {
      value: (_vm.showLineSchoolPopUp),
      callback: function($$v) {
        _vm.showLineSchoolPopUp = $$v
      },
      expression: "showLineSchoolPopUp"
    }
  }, [_c('div', {
    staticClass: "onlineSchoolLoginWay"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("网校账号登录")]), _vm._v(" "), _c('div', {
    staticClass: "desc"
  }, [_vm._v("此课程为VIP课程，需要登录后观看")]), _vm._v(" "), _c('div', {
    staticClass: "loginContent"
  }, [_c('div', {
    staticClass: "account"
  }, [_c('span', {
    staticClass: "area"
  }, [_vm._v("+86")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.onlineSchoolAccount),
      expression: "onlineSchoolAccount"
    }],
    staticClass: "loginInput",
    attrs: {
      "placeholder": "请输入手机号码"
    },
    domProps: {
      "value": (_vm.onlineSchoolAccount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.onlineSchoolAccount = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.loginType == 1) ? _c('div', {
    staticClass: "account"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.onlineSchoolPassword),
      expression: "onlineSchoolPassword"
    }],
    staticClass: "loginInput",
    attrs: {
      "type": "password",
      "placeholder": "请输入密码"
    },
    domProps: {
      "value": (_vm.onlineSchoolPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.onlineSchoolPassword = $event.target.value
      }
    }
  })]) : _c('div', {
    staticClass: "password"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.onLIneSchoolSMSCode),
      expression: "onLIneSchoolSMSCode"
    }],
    staticClass: "loginInput passwordInput",
    attrs: {
      "placeholder": "请输入验证码"
    },
    domProps: {
      "value": (_vm.onLIneSchoolSMSCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.onLIneSchoolSMSCode = $event.target.value
      }
    }
  }), _vm._v(" "), _c('van-button', {
    staticClass: "sendBtn",
    attrs: {
      "size": "small",
      "disabled": _vm.onlineSendMsgNum != 0,
      "type": "primary"
    },
    on: {
      "click": _vm.onlineLineSchoolSendMsg
    }
  }, [_vm._v(_vm._s(_vm.onlineSednMsgText))])], 1), _vm._v(" "), (_vm.loginType == 1) ? _c('van-button', {
    staticClass: "loginOnlineBtn",
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.onlineSchoolPWDLoginClick
    }
  }, [_vm._v("网校登录")]) : _c('van-button', {
    staticClass: "loginOnlineBtn",
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.onlineSchoolLoginClick
    }
  }, [_vm._v("网校登录")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#10a675",
      "margin-left": "30px"
    },
    on: {
      "click": function($event) {
        _vm.loginType == 1 ? (_vm.loginType = 2) : (_vm.loginType = 1)
      }
    }
  }, [_vm._v(_vm._s(_vm.loginType == 1 ? "验证码登录" : "账号密码登录"))])])], 1)])])], 1), _vm._v(" "), _c('LinkPopup', {
    attrs: {
      "isShow": _vm.linkDialogVisible,
      "linkType": _vm.linkType
    },
    on: {
      "accept": _vm.linkAccept,
      "refuse": _vm.linkRefuse
    }
  }), _vm._v(" "), (_vm.tosafariShow) ? _c('div', {
    staticClass: "tosafari"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('img', {
    attrs: {
      "src": "https://tengface-project.oss-cn-shenzhen.aliyuncs.com/tmp/quxiaofei.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.tosafariShow = false
      }
    }
  }, [_vm._v("我不需要连麦")])])])]) : _vm._e(), _vm._v(" "), (_vm.isShowLiveAnser) ? _c('liveanserPopup', {
    attrs: {
      "ds_id": _vm.ds_id,
      "channel_code": _vm.channel_id,
      "fans_id": _vm.fans_id,
      "uid": _vm.uid,
      "LiveanserObj": _vm.LiveanserObj
    },
    on: {
      "hideOrShowPop": _vm.hideliveAnser
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showShoppingType) ? _c('div', {
    staticClass: "shopping-cart",
    on: {
      "click": _vm.toGoodsDetailPage
    }
  }, [_c('div', {
    staticClass: "goods-pic"
  }, [_c('img', {
    attrs: {
      "src": _vm.goodsInfo.cover,
      "alt": "",
      "srcset": ""
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.goodsInfo.name))]), _vm._v(" "), _c('div', {
    staticClass: "pirce"
  }, [_c('span', [_vm._v("￥" + _vm._s(_vm.goodsInfo.price))]), _vm._v(" "), _c('span', {
    staticClass: "go"
  }, [_vm._v("抢")])]), _vm._v(" "), _c('van-icon', {
    staticClass: "close",
    attrs: {
      "name": "cross"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showShoppingType = false
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('van-popup', {
    staticClass: "shopping-dialog",
    model: {
      value: (_vm.showShoppingDialog),
      callback: function($$v) {
        _vm.showShoppingDialog = $$v
      },
      expression: "showShoppingDialog"
    }
  }, [_c('div', {
    staticClass: "shopping-dialog-content"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "goods-content"
  }, [_c('img', {
    staticClass: "goods-pic",
    attrs: {
      "src": _vm.goodsInfo.cover,
      "width": "96"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "goods-info"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.goodsInfo.name))]), _vm._v(" "), _c('p', {
    staticClass: "price"
  }, [_vm._v("￥" + _vm._s(_vm.goodsInfo.price))])])])]), _vm._v(" "), _c('div', {
    staticClass: "shopping-btn",
    on: {
      "click": _vm.toGoodsDetailPage
    }
  }, [_vm._v("立即抢购")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../statics/imgs/close-white.png")
    },
    on: {
      "click": _vm.hideShoppingPop
    }
  })])]), _vm._v(" "), (_vm.showBuyTipsState) ? [_c('div', {
    staticClass: "bug-tips user-buy-goods",
    class: [_vm.showBuyGoodsTips ? 'show' : 'hide']
  }, [_c('img', {
    attrs: {
      "src": require("../../statics/imgs/home/user-buy-goods.png"),
      "alt": "",
      "srcset": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "tips"
  }, [_c('span', {
    staticClass: "username"
  }, [_vm._v(_vm._s(_vm.tipsBuyUsername))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "flex-shrink": "0"
    }
  }, [_vm._v(_vm._s(_vm.tipsBuyText))])])]), _vm._v(" "), _c('div', {
    staticClass: "bug-tips buy-goods-success",
    class: [_vm.showBuySuccessGoodsTips ? 'show' : 'hide']
  }, [_c('img', {
    attrs: {
      "src": require("../../statics/imgs/home/user-buy-goods-success.png"),
      "alt": "",
      "srcset": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "tips"
  }, [_c('span', {
    staticClass: "username"
  }, [_vm._v(_vm._s(_vm.tipsBuySuccessUsername))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "flex-shrink": "0"
    }
  }, [_vm._v(_vm._s(_vm.tipsBuySuccessText))]), _vm._v(" "), (_vm.inventoryNum !== -1) ? _c('span', [_vm._v(", 库存剩余" + _vm._s(_vm.inventoryNum) + "件")]) : _vm._e()])])] : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "copyRight"
  }, [_c('span', [_vm._v("腾慧云直播")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-323786df"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 417
// module chunks = 0